<script>
    export default {
        methods: {
            isset(property) {
                if (typeof(property) != "undefined" && property !== null) {
                    return true;
                }
            }
        }
    }
</script>